<template>
  <div
    class="d-flex flex-column bg-light pt-3"
    style="margin: 0px -30px !important"
  >
    <div class="mx-auto w-100" :style="{ maxWidth: '1100px' }">
      <header class="text-center mb-3">
        <h2 class="display-5 font-weight-bold my-4">
          Clinical Placements &amp; Opportunities
        </h2>

        <nav class="d-flex justify-content-between flex-wrap my-4">
          <button
            v-for="tab in tabs"
            :key="tab"
            type="button"
            class="btn btn-tab mx-1 mb-2"
          >
            {{ tab }}
          </button>
        </nav>
      </header>

      <div class="card mb-4">
        <div class="card-body">
          <form class="form-row align-items-center w-100">
            <!-- Search keywords -->
            <div class="col-md-5 mb-2 mb-md-0">
              <TextInput placeholder="Search keywords" />
            </div>

            <!-- Location -->
            <div class="col-md-3 mb-2 mb-md-0">
              <TextInput placeholder="Location" />
            </div>

            <!-- Specialty -->
            <div class="col-md-2 mb-2 mb-md-0">
              <TextInput placeholder="Specialty" />
            </div>

            <!-- Post button -->
            <div class="col-md-2 d-flex justify-content-end">
              <button type="button" class="btn btn-primary w-100">Post</button>
            </div>
          </form>
        </div>
      </div>

      <div>
        <div
          v-for="(item, i) in filteredPlacements"
          :key="i"
          class="card mb-3 rounded"
        >
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-2 d-flex align-items-start pr-0">
                <div v-if="item.link">
                  <a :href="item.link" @click="openLink(item.link)">
                    <img
                      :src="item.logo"
                      :alt="'logo'"
                      class="img-fluid rounded"
                    />
                  </a>
                </div>
                <div v-else>
                  <img
                    :src="item.logo"
                    :alt="'logo'"
                    class="img-fluid rounded"
                  />
                </div>
              </div>

              <div class="col">
                <h5 class="mb-1 font-weight-bold">{{ item.title }}</h5>
                <div class="text-muted small">
                  {{ item.location }} &nbsp;•&nbsp; {{ item.duration }}
                </div>

                <div class="mt-3 d-flex flex-wrap align-items-center">
                  <div class="text-muted small mr-3">
                    <strong>Application Deadline:</strong> {{ item.deadline }}
                  </div>
                  <div class="d-flex flex-wrap">
                    <span
                      v-for="tag in item.tags"
                      :key="tag"
                      class="badge badge-light border mr-2 mb-1"
                    >
                      {{ tag }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                class="col-12 col-md-auto d-flex justify-content-md-end align-items-center mt-3 mt-md-0"
              >
                <button
                  type="button"
                  class="btn apply_btn"
                  @click="applyModal.isShowPopup = true"
                >
                  Apply Now
                </button>
                <!-- @click="openLink(item.loginLink)"  -->
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="filteredPlacements.length === 0"
          class="text-center text-muted py-4"
        >
          No opportunities match your filters.
        </div>
      </div>
    </div>
    <Modal
      :size="applyModal.size"
      :isShowPopup="applyModal.isShowPopup"
      :modalTitle="applyModal.modalTitle"
      :buttons="applyModal.buttons"
      @modalCallBack="handleAction"
    >
      <template #body class="p-0">
        <span class="h5 font-weight-bold" v-if="!applyModal.showLoginScreen">
          {{ applyModal.modalContent }}
        </span>
        <!-- Login -->
        <section class="main p-3" v-if="applyModal.showLoginScreen">
          <div class="col-12">
            <div class="card-bg">
              <h2 class="mb-5">
                Join the global health careers marketplace today
              </h2>

              <div class="login-box">
                <ValidationObserver ref="loginForm" v-slot="{ invalid }">
                  <form>
                    <!-- Email Input -->
                    <div class="mb-3">
                      <label for="email" class="form-label"
                        >Email Address*</label
                      >
                      <ValidationProvider
                        rules="required|email"
                        v-slot="{ errors }"
                        name="email"
                      >
                        <input
                          type="email"
                          id="email"
                          autocomplete="off"
                          class="custom-input"
                          v-model="dummy_form.email"
                        />
                        <span class="text-danger small">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <!-- Password Input -->
                    <div>
                      <label for="password" class="form-label">Password*</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="password"
                      >
                        <div class="password-field">
                          <input
                            :type="showPassword ? 'text' : 'password'"
                            id="password"
                            autocomplete="new-password"
                            class="custom-input"
                            v-model="dummy_form.password"
                          />
                          <i
                            :class="['fas', showPassword ? 'fa-eye-slash' : 'fa-eye', 'password-toggle-icon']"
                            @click="showPassword = !showPassword"
                          ></i>
                        </div>
                        <span class="text-danger small">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </section>
      </template>
    </Modal>
  </div>
</template>

<script>
import TextInput from "../components/reusable/Fields/TextInput.vue";
import ClevelandLogo from "../../public/img/cleveland_clinic.svg";
import NewYorkPresbyterianLogo from "../../public/img/newyork_presbyterian.png";
import UniversityTorontoLogo from "../../public/img/university_toronto.png";
import Modal from "@/components/reusable/CustomModal.vue";
import { required, email, confirmed } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import { mapActions } from "vuex";

extend("required", { ...required, message: "This field is required" });
extend("email", { ...email, message: "Invalid email address" });
extend("confirmed", {
  ...confirmed,
  message: "Email and confirm email should be same",
});

export default {
  name: "ClinicalPlacements",
  components: {
    TextInput,
    Modal,
  },
  data() {
    return {
      tabs: [
        "Observerships",
        "Fellowships",
        "Exchange Programs",
        "Internships",
        "Research",
      ],
      filters: { q: "", location: "", specialty: "" },
      placements: [
        {
          title: "Advanced General Pediatrics Fellowship",
          location: "Riyadh, KSA",
          duration: "2 Years",
          deadline: "October 15, 2025",
          tags: ["Paid", "On-site", "Paediatrics"],
          logo: "/img/stm/saudi_commission_3.png",
          link: "/tfm/partner/directory/scfhs",
          loginLink: "/tfm/partner/directory/scfhs#startApplication",
        },
        {
          title: "Neurology Observership",
          location: "New York, NY",
          duration: "4 Weeks",
          deadline: "October 01, 2025",
          tags: ["Unpaid", "On-site", "Neurology"],
          logo: NewYorkPresbyterianLogo,
        },
        {
          title: "Surgical Exchange Program",
          location: "Toronto, ON",
          duration: "6 Months",
          deadline: "October 25, 2025",
          tags: ["Unpaid", "On-site", "Surgery"],
          logo: UniversityTorontoLogo,
        },
        {
          title: "Oncology Internship",
          location: "Boston, MA",
          duration: "1 Year",
          deadline: "October 17, 2025",
          tags: ["Paid", "On-site", "Surgery"],
          logo: ClevelandLogo,
        },
        {
          title: "Cardiology Research Internship",
          location: "NewYork, NY",
          duration: "4 Months",
          deadline: "October 19, 2025",
          tags: ["Unpaid", "On-site", "Cardiology"],
          logo: NewYorkPresbyterianLogo,
        },
      ],
      applyModal: {
        isShowPopup: false,
        size: "md",
        showLoginScreen: false,
        modalTitle: "Apply Placements",
        modalContent: "You need to Login/Register to apply",
        buttons: [
          { label: "Close", type: "secondary", value: false },
          { label: "Ok", type: "primary", value: "login_page" },
        ],
      },
      dummy_form: {
        email: "",
        password: "",
      },
      showPassword: false,
    };
  },
  computed: {
    filteredPlacements() {
      const q = this.filters.q.trim().toLowerCase();
      const loc = this.filters.location.trim().toLowerCase();
      const spec = this.filters.specialty.trim().toLowerCase();

      return this.placements.filter((p) => {
        const hay = (
          p.title +
          " " +
          p.organization +
          " " +
          p.tags.join(" ")
        ).toLowerCase();
        const locationMatch = !loc || p.location.toLowerCase().includes(loc);
        const specialtyMatch =
          !spec || p.tags.join(" ").toLowerCase().includes(spec);
        const qMatch = !q || hay.includes(q);
        return locationMatch && specialtyMatch && qMatch;
      });
    },
  },
  methods: {
    ...mapActions(["showToast"]),
    openLink(link) {
      if (link) this.$router.push(link);
    },
    async submitLoginForm() {
      const isValid = await this.$refs.loginForm.validate();
      if (isValid) {
        this.applyModal.showLoginScreen = false;
        this.applyModal.modalContent =
          "Do you want to continue with your placement application?";
        this.applyModal.buttons = [
          { label: "Cancel", type: "secondary", value: "cancel" },
          { label: "Submit", type: "primary", value: "submit" },
        ];
      } else {
        this.showToast({
          class: "bg-danger text-white",
          message: "Please fill mandatory fields",
        });
      }
    },
    handleAction(action) {
      if (action === "login_page") {
        this.applyModal.showLoginScreen = true;
        this.applyModal.buttons = [
          { label: "Close", type: "secondary", value: false },
          { label: "Login", type: "primary", value: "login" },
        ];
      } else if (action === "login") {
        this.submitLoginForm();
      } else if (action === "submit") {
        this.applyModal.modalContent =
          "Your application has been submitted.You will receive a confirmation email shortly";
        this.applyModal.buttons = [
          { label: "Ok", type: "primary", value: false },
        ];
      } else if (action === "cancel") {
        this.applyModal.modalContent = "Your application has been cancelled";
        this.applyModal.buttons = [
          { label: "Ok", type: "primary", value: false },
        ];
      } else if (action === false) {
        this.applyModal = {
          isShowPopup: false,
          size: "md",
          showLoginScreen: false,
          modalTitle: "Apply Placements",
          modalContent: "You need to Login/Register to apply",
          buttons: [
            { label: "Close", type: "secondary", value: false },
            { label: "Ok", type: "primary", value: "login_page" },
          ],
        };
        this.dummy_form = {
          email: "",
          password: "",
        };
      }
    },
  },
};
</script>

<style scoped>
.password-field {
  position: relative;
}
.password-field .custom-input {
  padding-right: 2.5rem;
}
.password-field .password-toggle-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
}
.btn-primary {
  background-color: #331e94 !important;
  border: 2px solid #331e94 !important;
}
.btn.apply_btn {
  background-color: #fff !important;
  border: 2px solid #331e94 !important;
  color: #331e94 !important;
  font-weight: 600 !important;
}
.btn.apply_btn:hover {
  background-color: #331e94 !important;
  color: #fff !important;
}

.btn-tab {
  background-color: #f0f0f5 !important;
  border: 1px solid #c7c8d6 !important;
  color: #331e94 !important;
  font-weight: 600 !important;
}

.btn-tab:hover {
  background-color: #e2e2f1 !important;
  border-color: #331e94 !important;
  color: #331e94 !important;
}

.img-fluid {
  width: 166px !important;
  max-height: 66px !important;
  object-fit: contain !important;
}

.main {
  background: linear-gradient(
      0deg,
      rgba(40, 24, 97, 0.7),
      rgba(40, 24, 97, 0.7)
    ),
    linear-gradient(292deg, #9320f2, #4c34e9 50.45%, #18abf9);
  background-blend-mode: exclusion, normal;
  margin: -16px !important;
  color: white;
}

label {
  display: block;
  font-weight: bold;
}

input:not([type="radio"]):not([type="checkbox"]) {
  display: block;
  width: 100%;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
}
</style>
